import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Western Port Recycled Water Scheme - Project overview</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
        The Western Port Recycled Water Scheme will deliver Class A recycled water to agricultural areas in the south of Cardinia Shire, including Pakenham South, Cora Lynn, Vervale, Catani, Iona, Tynong and Bayles. 
        </p>
        <p>
        The scheme aims to increase the volume of a fit-for-purpose, alternative and sustainable water source to help the region adapt to a changing climate. The project will be delivered in two stages of recycled water pipelines, plus a new pump station located within the Pakenham Water Recycling Plant. 
        </p>
        <p>
          For up-to-date project information, click{' '}
          <a
            href="https://southeastwater.com.au/westernport"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Western Port Recycled Water Scheme - Project overview',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800407877 ">1800 407 877</a> |{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: ENGAGEMENT@SEW.COM.AU - Western Port Recycled Water Scheme - Project overview',
              });
            }}
          >
            engagement@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
